import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import KeyboardArrowDown from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUp from "@mui/icons-material/KeyboardArrowUp";
import { ToolbarIconButton } from "../../toolbar/toolbar-icon-button";

import type { FC } from "react";

export const InsertRowButtons: FC<{ handleInsertRow: (insertAfter: boolean) => void }> = ({
  handleInsertRow,
}) => {
  const [editor] = useLexicalComposerContext();
  return (
    <>
      <ToolbarIconButton
        data-analytics-id="lexical-table-menu-insert-row-above"
        disabled={!editor._editable}
        label="Insert row above"
        icon={<KeyboardArrowUp fontSize="small" />}
        data-testid="table-menu-insert-row-above"
        aria-label="insert-row-above"
        onClick={() => handleInsertRow(false)}
      />
      <ToolbarIconButton
        data-analytics-id="lexical-table-menu-insert-row-below"
        disabled={!editor._editable}
        label="Insert row below"
        icon={<KeyboardArrowDown fontSize="small" />}
        data-testid="table-menu-insert-row-below"
        aria-label="insert-row-below"
        onClick={() => handleInsertRow(true)}
      />
    </>
  );
};
